module.exports = __webpack_public_path__ + "img/DNARepair-OPSCC_PMID37704757.fe21da17.png";